import Router from "next/router";

export const Redirect = (context, target, status = 302) => {
    if (context && context.res) {
        return context.res.redirect(Number(status), target);
    } else {
        Router.push(target);
    }
};